import { version } from '../../../package.json'
export const PACKAGE_VERSION = version
